/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { NotificaAllegatoInfoDto } from '../../models/notifica-allegato-info-dto';

export interface ApiNotificaNotificaAllegatoInfoListGet$Params {
    /**
     * Id della notifica da caricare
     */
    notificaId: number;
}

export function apiNotificaNotificaAllegatoInfoListGet(
    http: HttpClient,
    rootUrl: string,
    params: ApiNotificaNotificaAllegatoInfoListGet$Params,
    context?: HttpContext,
): Observable<StrictHttpResponse<Array<NotificaAllegatoInfoDto>>> {
    const rb = new RequestBuilder(rootUrl, apiNotificaNotificaAllegatoInfoListGet.PATH, 'get');
    if (params) {
        rb.query('notificaId', params.notificaId, {});
    }

    return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
            return r as StrictHttpResponse<Array<NotificaAllegatoInfoDto>>;
        }),
    );
}

apiNotificaNotificaAllegatoInfoListGet.PATH = '/api/notifica/notifica-allegato-info-list';
